// Core
import { createAsyncThunk } from '@reduxjs/toolkit';

// Boosters
import { AxiosError } from 'axios';
import { axiosInstance } from '../../index';
import {
  LeaderboardRewardsResponse, TopPlayersResponse,
} from '../../../types';
import { RewardsType } from '../../../types/constants';
// Types

export const getTopPlayers = createAsyncThunk<TopPlayersResponse>(
  'topplayers/all',
  async (topPlayers, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get('users/top');
      return data;
    } catch (error) {
      const err = error as AxiosError;
      return rejectWithValue(err);
    }
  },
);

export const getTopLeaguesReward = createAsyncThunk<LeaderboardRewardsResponse>(
  'league/rewards',
  async (topPlayers, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get('users/rewards/active?type=league_update');
      return data;
    } catch (error) {
      const err = error as AxiosError;
      return rejectWithValue(err);
    }
  },
);

export const claimLeaderboardRewards = createAsyncThunk<
    LeaderboardRewardsResponse,
    {ids: number[]}
>(
  'league/claim/rewards',
  async ({ ids }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post('users/rewards/claimAll', { ids, type: RewardsType.LEAGUE_UPDATE });
      return data;
    } catch (error) {
      const err = error as AxiosError;
      return rejectWithValue(err);
    }
  },
);
